import { FULFILMENT_PASS_USER_LOADED } from '../../actionTypes/fulfilmentPassActionTypes'

const fulfilmentPassUserLoaded = userId => ({
  type: FULFILMENT_PASS_USER_LOADED,
  payload: { userId }
})

export { fulfilmentPassUserLoaded }
